<template>
    <div class="it-header-center-wrapper">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="it-header-center-content-wrapper">
              <div class="it-brand-wrapper">
                <a href="#">
                  <img id="unibo-logo-header" src="static/logo.svg" alt="Torna alla pagina iniziale">
                  <div class="it-brand-text">
                    <h2 class="no_toc">Pronunce della Corte Costituzionale</h2>
                    <h3 class="no_toc d-md-block">
                      Versione Akoma Ntoso a cura del CIRSFID, Università di Bologna
                    </h3>
                  </div>
                </a>
              </div>
              <div class="it-right-zone">
                <div class="it-search-wrapper">
                  <span class="d-none d-md-block">Cerca</span>
                  <a aria-label="Cerca" class="search-link rounded-icon" href="#" data-toggle="modal" data-target="#modalsearch">
                    <svg class="icon">
                      <use :xlink:href="icons.itSearch"></use>
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>


<script>
import sprites from 'bootstrap-italia/dist/svg/sprite.svg';

export default {
  name: 'HeaderCenter',
  data() {
    return {
      icons: {
        itExpand: `${sprites}#it-expand`,
        itDesignersItalia: `${sprites}#it-designers-italia`,
        itFacebook: `${sprites}#it-facebook`,
        itTwitter: `${sprites}#it-twitter`,
        itGithub: `${sprites}#it-github`,
        itSearch: `${sprites}#it-search`,
        itBurger: `${sprites}#it-burger`,
      },
    };
  },
  components: {
  },
};
</script>

<style lang="less" scoped>
  .it-brand-wrapper{
    #unibo-logo-header{
      width:4em;
      margin-right:5px;
    }
    &.cloned{
      #unibo-logo-header{
        width:2.5em;
        margin-right:5px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/header/HeaderCenter.vue